// @flow
import { createParser, fields } from '../utils/parse';

export const CoinProduct = createParser('CoinProduct', {
  amount: fields.number(-1, { path: 'credits' }),
  id: fields.number(-1),
  name: fields.string('', { path: 'name' }),
  price: fields.string('', { path: 'formatted_price' }),
});

export default CoinProduct;
